import { Button, IconButton, makeStyles } from "@material-ui/core";
import React, { useMemo, useRef } from "react";
import { MdClose } from "react-icons/md"
import { obterMensagemApiException } from "../../functions";
import { animarSaidaModal, criarAlerta } from "../../functions";
import { useGlobalContext } from "../../hooks";
import { TSeverityNotificacao } from "../../interfaces";

interface IModalConfirmaExclusaoSolicitacoesProps {
    estaExcluindoItens: boolean;
    fecharModal: () => void;
    onClickConfirmar: () => Promise<void>;
}

const useThisStyles = makeStyles(theme => ({

    containerModal: {
        position: 'fixed',
        zIndex: 4,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down(620)]: {
            padding: '0 1em'
        }

    },

    corpo: {
        backgroundColor: 'white',
        borderRadius: '0.3em',
        boxShadow: '0 0 0 101vw rgba(0,0,0,0.5)'
    },

    header: {
        padding: '0.3em 1em',
        color: '#777777',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontWeight: 600,
        borderBottom: '1px solid #EEEEEE',

        "& svg": {
            width: '1em',
            height: '1em',
        }

    },

    conteudo: {

        maxWidth: '52ch',
        display: 'grid',
        rowGap: '1em',
        padding: '1em',

        "& span": {
            fontSize: '1.1em',
            color: '#464665',
            textAlign: 'center',
        },


        [theme.breakpoints.down(620)]: {
            paddingBottom: '0.5em'
        }

    },


    botoes: {

        padding: '1em',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        columnGap: '1em',

        "& button": {
            textTransform: 'none',
            height: '3.5em'
        },

        [theme.breakpoints.down(620)]: {
            gridTemplateColumns: '1fr',
            rowGap: '1em',

            "& button:nth-child(2)": {
                gridRow: 1
            }
        },
    },
}));

export const ModalConfirmaExclusaoSolicitacoes: React.FC<IModalConfirmaExclusaoSolicitacoesProps> = ({ 
    fecharModal, onClickConfirmar, estaExcluindoItens
}) => {

    const classes = useThisStyles();

    const refModal = useRef<HTMLElement>(null);

    const { 
        itensSequecialAhNegarNegociacao,
        setMotivoRespostaSolicitacao,
        setNotificacao
    } = useGlobalContext();

    const notificar = (severity: TSeverityNotificacao, message: string) => criarAlerta(severity, message, setNotificacao);

    const handleClickCancelar = async () => {

        await animarSaidaModal(refModal);

        setMotivoRespostaSolicitacao('');

        fecharModal();

    }

    const handleClickConfirmar = async () => {

        try {

            await onClickConfirmar();

            await animarSaidaModal(refModal);

            fecharModal();

        } catch (error) {
            notificar(
                'error',
                obterMensagemApiException(error),
            );
        }
    }

    const itensSequecialAhNegarNegociacaoOrdenado: number[] = useMemo(
        () => [...itensSequecialAhNegarNegociacao].sort((a, b) => a - b)
            ,[itensSequecialAhNegarNegociacao]
    )

    return <article className={classes.containerModal}>

        <section ref={refModal} className={`${classes.corpo} zoomIn`}>

            <div className={classes.header}>

                <p>Confirmação</p>

                <IconButton
                    onClick={handleClickCancelar}
                    disabled={estaExcluindoItens}
                >
                    <MdClose />
                </IconButton>

            </div>

            <div className={classes.conteudo}>

                <span>Você tem certeza que deseja recusar as seguintes solicitações: </span>

                {itensSequecialAhNegarNegociacaoOrdenado.map((item) =>(
                    <strong>{item}</strong>
                ))}
            </div>

            <div className={classes.botoes}>

                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClickCancelar}
                    disabled={estaExcluindoItens}
                    >
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClickConfirmar}
                    disabled={estaExcluindoItens}
                >
                    Confirmar
                </Button>

            </div>

        </section>

    </article>

}
